module.exports = __webpack_public_path__ + "static/img/ZM.4dc0dd24.jpg";